'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	themeStyleMap = {
		background: 'backgroundColor',
		borderColor: 'lineColor'
	};
mmWidgets.fn.nodeStyleEditorColorPickerWidget = function (colorPickerModel, nodeStyleEditorModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			styleAttr = widget.attr('data-mm-node-style-color'),
			themeAttr = themeStyleMap[styleAttr] || styleAttr;

		widget.click(() => {
			colorPickerModel.pickColor()
			.then(color => nodeStyleEditorModel.setStyleValue(styleAttr, color))
			.catch((/*reason*/) => {
				//console.error('reason', reason);//eslint-disable-line
				nodeStyleEditorModel.showEditor();
			});
			nodeStyleEditorModel.hideEditor();
		});
		nodeStyleEditorModel.addEventListener('showNodePreview', () => {
			const color = nodeStyleEditorModel.getThemeValue(themeAttr);
			widget.domElements[0].style.backgroundColor =  color;
		});
	});

};
